const { getOffsetTop } = window.BAO.Utils

class CollectionHighlights extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    /* eslint-disable-next-line no-undef */
    if (Shopify.designMode) return

    window.setTimeout(() => {
      this.updateEl()
    }, 500)

    this.activeIndex = '1'

    this.isTicking = false
    this.lastKnownY = window.scrollY

    this.requestTick = this.requestTick.bind(this)
    this.updateEl = this.updateEl.bind(this)
  }

  setupListeners () {
    super.setupListeners()

    this.onScroll = this.onScroll.bind(this)
    this.onMouseMove = this.onMouseMove.bind(this)

    window.addEventListener('scroll', this.onScroll, { passive: true })

    window.addEventListener('pointermove', this.onMouseMove)
  }

  onScroll () {
    this.lastKnownY = window.scrollY

    this.requestTick()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)

    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false

    this.updateItems()
  }

  onMouseMove (event) {
    if (!window.BAO.MediaBreakpoints.isMd) return

    const matchedItem = event.target.closest(this.els.trigger.selector)

    if (!matchedItem) return

    this.setActiveItem(matchedItem.dataset.index)
  }

  updateItems () {
    if (window.BAO.MediaBreakpoints.isMd) return

    const containerOffsetTop = getOffsetTop(this.els.items.element)

    const elementStartPoint = containerOffsetTop - window.innerHeight / 2
    const elementEndPoint =
      elementStartPoint + this.els.items.element.offsetHeight

    if (this.lastKnownY <= elementStartPoint) {
      this.setActiveItem('1')

      return
    }

    if (this.lastKnownY > elementEndPoint) {
      this.setActiveItem(this.els?.item?.elements.length.toString())

      return
    }

    const totalScrollAmount = elementEndPoint - elementStartPoint

    const scrollYAsAPercentageOfJourney =
      (this.lastKnownY - elementStartPoint) / totalScrollAmount

    const triggerEls = this.querySelectorAll(
      '[data-collection-highlights-el="trigger"]',
    )

    triggerEls.forEach((triggerEl, index) => {
      const minimumPercent = index / this.els?.trigger?.elements.length
      const maximumPercent = (index + 1) / this.els?.trigger?.elements.length
      const isWithinRange =
        scrollYAsAPercentageOfJourney >= minimumPercent &&
        scrollYAsAPercentageOfJourney < maximumPercent

      if (isWithinRange) {
        this.setActiveItem(triggerEl.dataset.index)
      }
    })
  }

  setActiveItem (newIndex) {
    if (this.activeIndex === newIndex) return

    this.activeIndex = newIndex

    const triggerEls = this.querySelectorAll(
      '[data-collection-highlights-el="trigger"]',
    )
    const mediaEls = this.querySelectorAll(
      '[data-collection-highlights-el="media"]',
    )

    triggerEls.forEach((triggerEl) => {
      triggerEl.setAttribute(
        'aria-pressed',
        triggerEl.dataset.index === this.activeIndex,
      )
    })

    mediaEls.forEach((mediaEl) => {
      mediaEl.setAttribute(
        'aria-hidden',
        mediaEl.dataset.index !== this.activeIndex,
      )
    })
  }
}

if (!customElements.get('collection-highlights')) {
  customElements.define('collection-highlights', CollectionHighlights)
}
